import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 25px;

  img {
    width: 100.52px;
  }

  div {
    display: flex;
    align-items: center;

    span {
      font-size: 10px;
      color: #666;
      margin-right: 4px;
    }

    img {
      width: 42px;
    }
  }
`;
